$(document).ready(function () {
    let isDropdownActive = false;

    $(document).on('click', function (event) {
        let container = $('.action__select-variant.active')[0];

        if (isDropdownActive && !container.contains(event.target)) {
            $('.action__select-variant.active').removeClass('active');
            isDropdownActive = false;
            return false;
        }
    });

    $(document).on('click', '.select-button', function () {
        const $variantSelector = $(this).closest('.action__select-variant');

        if (!isDropdownActive || $(this).closest('.action__select-variant').hasClass('active')) {
            if ($variantSelector.hasClass('active')) {
                isDropdownActive = false;
                $variantSelector.removeClass('active');
            } else {
                isDropdownActive = true;
                $variantSelector.addClass('active');
            }
            $(this).attr("aria-expanded", $('.select-button').attr("aria-expanded") === "true" ? "false" : "true");
        }
    });

    $(document).on('click', '.choice-container', function () {
        isDropdownActive = false;
        var $dropdownVariant = $(this).closest('.action__select-variant');
        var $sku = $(this).parent().attr("sku");

        $dropdownVariant.find("select.select-variant").val($sku).change();
        $dropdownVariant.find('.selected-value').text($(this).attr("desc"));
        $dropdownVariant.find('.color-indicator').attr('src', $(this).find('.color-indicator').attr('src'));
        $dropdownVariant.removeClass('active');
    });
});
